module.exports = __webpack_public_path__ + "static/media/Koffing_gaussian2.39f8c3a1.png";